module.exports = __webpack_public_path__ + "img/seta-para-baixo.bdd0b1bf.svg";